module.exports = __webpack_public_path__ + "97a7e82d74baca62410637029932b1f3.pdf";